// ============================================================
// Gap Finder — Keyword Dictionary
// Six gap types with detection phrases
// ============================================================

export const GAP_TYPES = {
  THEORETICAL: {
    label: 'Theoretical Gap',
    color: '#6366f1',
    description: 'Missing or underdeveloped theoretical frameworks or concepts.',
    keywords: [
      'theoretical framework', 'theory lacks', 'theoretical gap', 'conceptual gap',
      'theoretical foundation', 'lacks theoretical', 'theoretical underpinning',
      'conceptual framework', 'theoretical basis', 'theoretical lens',
      'theoretical grounding', 'theoretical development', 'theory building',
      'theoretical extension', 'theoretical advancement', 'conceptual clarity',
      'theoretical explanation', 'theoretical understanding', 'theoretical contribution',
      'theoretical model', 'extend the theory', 'theoretical integration',
    ],
  },
  EMPIRICAL: {
    label: 'Empirical Gap',
    color: '#22c55e',
    description: 'Insufficient empirical evidence or data to support claims.',
    keywords: [
      'empirical evidence', 'empirical gap', 'empirical study', 'lacks empirical',
      'empirical research', 'empirical validation', 'empirical data', 'lack of data',
      'insufficient evidence', 'limited empirical', 'empirical testing',
      'empirical investigation', 'empirical findings', 'empirical basis',
      'more data needed', 'data scarce', 'empirical support', 'empirical examination',
      'limited studies', 'few studies', 'scant research', 'under-researched',
      'limited research', 'little research', 'minimal research',
    ],
  },
  METHODOLOGICAL: {
    label: 'Methodological Gap',
    color: '#f59e0b',
    description: 'Flaws or absences in research design, methods or measurement.',
    keywords: [
      'methodological gap', 'methodological limitation', 'research design',
      'measurement issues', 'sampling limitation', 'methodological weakness',
      'methodological approach', 'research method', 'mixed methods',
      'qualitative approach', 'quantitative approach', 'methodological rigor',
      'methodological advancement', 'improved methodology', 'robust methodology',
      'measurement validity', 'measurement reliability', 'instrument limitation',
      'sample size', 'sampling bias', 'selection bias', 'response bias',
      'cross-sectional', 'longitudinal study needed', 'replication needed',
    ],
  },
  CONTEXTUAL: {
    label: 'Contextual Gap',
    color: '#ec4899',
    description: 'Missing studies in specific geographic, cultural or demographic contexts.',
    keywords: [
      'contextual gap', 'geographic context', 'cultural context', 'demographic gap',
      'specific context', 'developing countries', 'developed countries',
      'regional study', 'cross-cultural', 'cultural difference',
      'underrepresented population', 'specific population', 'demographic group',
      'generalizability', 'transferability', 'context-specific',
      'limited to', 'restricted to', 'focused on', 'specific sector',
      'industry-specific', 'country-specific', 'culture-specific',
      'urban', 'rural', 'sector', 'industry', 'population',
    ],
  },
  CONTRADICTORY: {
    label: 'Contradictory Gap',
    color: '#ef4444',
    description: 'Conflicting findings across studies that require resolution.',
    keywords: [
      'contradictory findings', 'conflicting results', 'inconsistent findings',
      'mixed results', 'contradictory evidence', 'conflicting evidence',
      'inconsistent results', 'debate in literature', 'controversial',
      'conflicting studies', 'inconsistent', 'divergent findings',
      'disparate findings', 'opposing views', 'conflicting perspectives',
      'mixed evidence', 'equivocal findings', 'inconclusive',
      'no consensus', 'lack of consensus', 'disagreement', 'paradox',
    ],
  },
  PRACTICAL: {
    label: 'Practical Gap',
    color: '#0ea5e9',
    description: 'Disconnect between research findings and real-world application.',
    keywords: [
      'practical gap', 'practical implication', 'real-world application',
      'practical application', 'implementation gap', 'practice gap',
      'policy implication', 'practitioner', 'applied research',
      'practical relevance', 'practical significance', 'industry application',
      'real-world context', 'real-world setting', 'implementation',
      'policy recommendation', 'practical contribution', 'applied setting',
      'practitioners need', 'industry needs', 'organizational context',
      'managerial implication', 'policy gap', 'implementation barrier',
    ],
  },
};

export const LIMITATION_PHRASES = [
  'future research should', 'future studies should', 'future research could',
  'future research may', 'further research is needed', 'further study is needed',
  'this study is limited', 'limitation of this study', 'limitations include',
  'this research is limited', 'limited by', 'limited to', 'acknowledges that',
  'future research', 'further investigation', 'further research',
  'should be explored', 'warrants further', 'remains to be explored',
  'calls for further', 'needs further', 'yet to be examined',
  'has not been studied', 'has not been explored', 'has not been investigated',
  'little attention', 'limited attention', 'insufficient attention',
  'gap in literature', 'gap in the literature', 'gap exists',
  'under-explored', 'under-researched', 'under-investigated',
  'little is known', 'scant literature', 'scarce literature',
];
